import { Box, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'

import { useVirtualboardStore } from '../../store/virtualboard.store'
import { Icons } from "../../utils/virtualboard-utilities"

const CanvasBottomNavbar = observer( ( { onChange } ) => {

    const { palette } = useTheme()
    const store = useVirtualboardStore()

    const moveSlideBy = ( offset ) => {
        let moved = store.moveSlideBy( offset )
        moved = moved ?? false
        if ( onChange && typeof onChange === 'function' && ( moved || moved === 0 ) )
            onChange( { type: "slide-change", newSlideIndex: moved, pageId: store.getBoardState?.document?.slides[store.getBoardState?.currentSlide].id } )
    }

    return (
        <Box bgcolor={palette.contentBg} borderRadius="0 0 10px 10px" minWidth={`${store.getDimentions.canvas.width}px`} display="grid" padding="10px" gridTemplateColumns="1fr 1fr 1fr" alignItems="center" >
            <Tooltip disableInteractive title={store.getBoardState?.document?.name}>
                <Typography maxWidth="60px" textAlign="left" noWrap fontStyle="italic" component="p" fontSize="12px" >{store.getBoardState?.document?.name}</Typography>
            </Tooltip>
            <Box display="flex" justifyContent="center" gap="5px" alignItems="center">
                <Tooltip title="Previous Slide">
                    <IconButton onClick={() => moveSlideBy( -1 )} size='small'>
                        {Icons.default.ChevronLeft}
                    </IconButton>
                </Tooltip>
                <Box display="flex" flexDirection="column" alignItems="center">
                    <Typography fontSize="10px">
                        Slide {store.getBoardState.currentSlide + 1}
                    </Typography>
                    <Typography marginTop="-2px" fontSize="8px">
                        {store.getBoardState.currentSlide + 1} of  {store.getBoardState.document?.slides?.length}
                    </Typography>
                </Box>
                <Tooltip title="Next Slide">
                    <IconButton onClick={() => moveSlideBy( 1 )} size='small'>
                        {Icons.default.ChevronRight}
                    </IconButton>
                </Tooltip>
            </Box>
            <Box display="flex" gap="5px" justifyContent="flex-end" alignItems="center">
                <Typography textAlign="right" fontSize="12px">
                    {Math.round( store.getZoom * 100 )}%
                </Typography>
            </Box>
        </Box >
    )
} )

export default CanvasBottomNavbar
